module.exports = __webpack_public_path__ + "static/media/onlinephysiotherapy_mockup_video.11d00aad.svg";